/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FieldRequireTypes,
    FieldRequireTypesFromJSON,
    FieldRequireTypesFromJSONTyped,
    FieldRequireTypesToJSON,
} from './';

/**
 * 
 * @export
 * @interface FailureStatusVm
 */
export interface FailureStatusVm {
    /**
     * 
     * @type {string}
     * @memberof FailureStatusVm
     */
    alternativeName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FailureStatusVm
     */
    isSpecialCase?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FailureStatusVm
     */
    isDefault?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FailureStatusVm
     */
    requiresWorkbookTask?: boolean;
    /**
     * 
     * @type {FieldRequireTypes}
     * @memberof FailureStatusVm
     */
    requiresStateChangeReason?: FieldRequireTypes;
    /**
     * 
     * @type {string}
     * @memberof FailureStatusVm
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FailureStatusVm
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FailureStatusVm
     */
    isSealed?: boolean;
}

export function FailureStatusVmFromJSON(json: any): FailureStatusVm {
    return FailureStatusVmFromJSONTyped(json, false);
}

export function FailureStatusVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailureStatusVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'alternativeName': !exists(json, 'alternativeName') ? undefined : json['alternativeName'],
        'isSpecialCase': !exists(json, 'isSpecialCase') ? undefined : json['isSpecialCase'],
        'isDefault': !exists(json, 'isDefault') ? undefined : json['isDefault'],
        'requiresWorkbookTask': !exists(json, 'requiresWorkbookTask') ? undefined : json['requiresWorkbookTask'],
        'requiresStateChangeReason': !exists(json, 'requiresStateChangeReason') ? undefined : FieldRequireTypesFromJSON(json['requiresStateChangeReason']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'isSealed': !exists(json, 'isSealed') ? undefined : json['isSealed'],
    };
}

export function FailureStatusVmToJSON(value?: FailureStatusVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'alternativeName': value.alternativeName,
        'isSpecialCase': value.isSpecialCase,
        'isDefault': value.isDefault,
        'requiresWorkbookTask': value.requiresWorkbookTask,
        'requiresStateChangeReason': FieldRequireTypesToJSON(value.requiresStateChangeReason),
        'id': value.id,
        'name': value.name,
        'isSealed': value.isSealed,
    };
}


